/**
 * Router Config
 * Sets the default title
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */

import router from '../router/router'
import {Loading} from 'element-ui'

let routerLoader

router.beforeEach((to, from, next) => {
  routerLoader = Loading.service()
  let title = to.meta ? to.meta.title : null
  document.title = title ? title + ' - ' : ''
  document.title += ' ' + process.env.APP_NAME
  next()
})

router.afterEach(() => {
  routerLoader.close()
})



// WEBPACK FOOTER //
// ./src/config/router.config.js